import React from 'react';

interface ColoredWhitespaceProps {
    text: string;
    whitespaceColor?: string;
}

const ColoredWhitespace: React.FC<ColoredWhitespaceProps> = ({ text, whitespaceColor = '#FFF7F0' }) => {
    const coloredText = text.replace(/ /g, `<span style="background-color: ${whitespaceColor};">&nbsp;</span>`);

    return <span dangerouslySetInnerHTML={ { __html: coloredText } } />;
};

export default ColoredWhitespace;